import React, { useEffect, useReducer } from 'react';

import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

const DEFAULT_TICK_MS = 60000;

const RelativeTime = ({
  value = null,
  children = undefined,
  className = undefined,
  tickMs = DEFAULT_TICK_MS,
}) => {
  const [, refresh] = useReducer((count) => count + 1, 0);

  useEffect(() => {
    if (!value) return undefined;

    const intervalId = setInterval(refresh, tickMs);
    return () => clearInterval(intervalId);
  }, [value, tickMs]);

  if (!value) return null;

  const relativeTimeLabel = dayjs(value).fromNow();

  if (typeof children === 'function') {
    return children(relativeTimeLabel);
  }

  return (
    <span className={className}>
      {relativeTimeLabel}
    </span>
  );
};

RelativeTime.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]),
  children: PropTypes.func,
  className: PropTypes.string,
  tickMs: PropTypes.number,
};

export default RelativeTime;
